// Coluna "Preço" da listagem de produtos lê `discount` (preço cheio) e "Preço
// com Desconto" lê `price`. Sem discount (ex.: produto vindo do
// createProductsSku, que só manda price) não há desconto: o preço cheio é o
// próprio price. Só exibição — nada é salvo.
export function fullPriceForList(row) {
  return Number(row?.discount) > 0 ? row.discount : row?.price;
}
